/**
 * PDP Real Life Gallery - Desktop carousel + Mobile scroller + Lightbox
 * Supports both images and videos
 */
(function() {
  'use strict';

  var gallery = document.querySelector('.pdp-rl-gallery');
  if (!gallery) return;

  // --- Desktop Grid Carousel ---
  var grid = document.getElementById('pdp-rl-grid');
  var items = grid ? grid.querySelectorAll('.pdp-rl-gallery__item') : [];
  var prevBtn = gallery.querySelector('.pdp-rl-gallery__arrow--prev');
  var nextBtn = gallery.querySelector('.pdp-rl-gallery__arrow--next');
  var pageDots = gallery.querySelectorAll('.pdp-rl-gallery__page-dot');
  var currentPage = 0;
  var itemsPerPage = 3;
  var totalPages = Math.ceil(items.length / itemsPerPage);

  var isAnimating = false;

  function showPage(page, animate, direction) {
    if (isAnimating) return;
    var newPage = ((page % totalPages) + totalPages) % totalPages;
    if (newPage === currentPage && animate) return;

    // Auto-detect direction if not provided
    if (!direction) direction = newPage > currentPage ? 'next' : 'prev';

    function applyPage() {
      currentPage = newPage;
      var start = currentPage * itemsPerPage;
      var end = start + itemsPerPage;

      items.forEach(function(item, i) {
        item.classList.toggle('is-visible', i >= start && i < end);
      });

      pageDots.forEach(function(dot, i) {
        dot.classList.toggle('is-active', i === currentPage);
      });
    }

    if (animate && grid) {
      isAnimating = true;
      // Slide out in the correct direction
      var outClass = direction === 'next' ? 'is-sliding-out-left' : 'is-sliding-out-right';
      var inClass = direction === 'next' ? 'is-sliding-in-right' : 'is-sliding-in-left';

      grid.classList.add(outClass);

      setTimeout(function() {
        applyPage();
        grid.classList.remove(outClass);
        grid.classList.add(inClass);
        void grid.offsetWidth;

        grid.classList.remove(inClass);
        setTimeout(function() {
          isAnimating = false;
        }, 500);
      }, 500);
    } else {
      applyPage();
    }
  }

  if (items.length > 0) showPage(0, false);

  if (prevBtn) prevBtn.addEventListener('click', function() { showPage(currentPage - 1, true, 'prev'); });
  if (nextBtn) nextBtn.addEventListener('click', function() { showPage(currentPage + 1, true, 'next'); });

  pageDots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      showPage(parseInt(this.getAttribute('data-page')), true);
    });
  });

  // --- Mobile Scroller Dots ---
  var scroller = document.getElementById('pdp-rl-scroller');

  if (scroller) {
    var scrollItems = scroller.querySelectorAll('.pdp-rl-gallery__scroll-item');
    var mobileDotsWrap = gallery.querySelector('.pdp-rl-gallery__dots');
    var mobileGroupStarts = [];
    var mobileScrollTimer = null;
    var isProgrammaticMobileScroll = false;

    scroller.setAttribute('data-item-count', String(scrollItems.length));

    scrollItems.forEach(function(item) {
      item.classList.remove('is-snap-start');
    });

    if (scrollItems.length <= 2) {
      mobileGroupStarts = [0];
    } else {
      for (var groupStart = 0; groupStart < scrollItems.length; groupStart += 2) {
        mobileGroupStarts.push(groupStart);
      }
    }

    mobileGroupStarts.forEach(function(startIndex) {
      if (scrollItems[startIndex]) {
        scrollItems[startIndex].classList.add('is-snap-start');
      }
    });

    if (mobileDotsWrap) {
      mobileDotsWrap.innerHTML = '';
      mobileGroupStarts.forEach(function(startIndex, pageIndex) {
        var dot = document.createElement('button');
        dot.className = 'pdp-rl-gallery__dot' + (pageIndex === 0 ? ' is-active' : '');
        dot.setAttribute('data-index', String(startIndex));
        dot.setAttribute('aria-label', 'Go to gallery group ' + (pageIndex + 1));
        mobileDotsWrap.appendChild(dot);
      });
      mobileDotsWrap.hidden = mobileGroupStarts.length <= 1;
    }

    function maxMobileScrollLeft() {
      return Math.max(0, scroller.scrollWidth - scroller.clientWidth);
    }

    function targetLeftForMobileIndex(index) {
      var target = scrollItems[index];
      if (!target) return 0;
      return Math.min(target.offsetLeft, maxMobileScrollLeft());
    }

    function closestMobileGroupIndex() {
      var currentLeft = scroller.scrollLeft;
      var closestPage = 0;
      var closestDistance = Infinity;

      mobileGroupStarts.forEach(function(startIndex, pageIndex) {
        var distance = Math.abs(currentLeft - targetLeftForMobileIndex(startIndex));
        if (distance < closestDistance) {
          closestDistance = distance;
          closestPage = pageIndex;
        }
      });

      return closestPage;
    }

    function updateMobileDots() {
      var activePage = closestMobileGroupIndex();
      var mobileDots = mobileDotsWrap ? mobileDotsWrap.querySelectorAll('.pdp-rl-gallery__dot') : [];
      mobileDots.forEach(function(dot, i) {
        dot.classList.toggle('is-active', i === activePage);
      });
    }

    function snapToClosestMobileGroup() {
      if (isProgrammaticMobileScroll || mobileGroupStarts.length <= 1) {
        updateMobileDots();
        return;
      }

      var activePage = closestMobileGroupIndex();
      var activeStart = mobileGroupStarts[activePage];
      isProgrammaticMobileScroll = true;
      scroller.scrollTo({ left: targetLeftForMobileIndex(activeStart), behavior: 'smooth' });
      window.setTimeout(function() {
        isProgrammaticMobileScroll = false;
        updateMobileDots();
      }, 350);
    }

    scroller.addEventListener('scroll', function() {
      updateMobileDots();
      window.clearTimeout(mobileScrollTimer);
      mobileScrollTimer = window.setTimeout(snapToClosestMobileGroup, 140);
    }, { passive: true });

    if (mobileDotsWrap) mobileDotsWrap.querySelectorAll('.pdp-rl-gallery__dot').forEach(function(dot) {
      dot.addEventListener('click', function() {
        var index = parseInt(this.getAttribute('data-index'));
        isProgrammaticMobileScroll = true;
        scroller.scrollTo({ left: targetLeftForMobileIndex(index), behavior: 'smooth' });
        window.setTimeout(function() {
          isProgrammaticMobileScroll = false;
          updateMobileDots();
        }, 350);
      });
    });
  }

  // --- Collect all media items (images + videos) ---
  function getAllMedia() {
    var allItems = gallery.querySelectorAll('[data-index]');
    var media = [];
    var seen = {};
    allItems.forEach(function(item) {
      var idx = item.getAttribute('data-index');
      if (seen[idx]) return;
      seen[idx] = true;
      var type = item.getAttribute('data-type') || 'image';
      if (type === 'video') {
        // Get video URL from data attribute on play button, or from video element
        var playBtn = item.querySelector('[data-video-src]');
        var video = item.querySelector('video');
        var src = (playBtn && playBtn.getAttribute('data-video-src')) || (video && video.src) || '';
        media.push({ type: 'video', src: src });
      } else {
        var img = item.querySelector('img');
        media.push({ type: 'image', src: img ? (img.currentSrc || img.src) : '' });
      }
    });
    return media;
  }

  // --- Lightbox ---
  var lightbox = document.getElementById('pdp-rl-lightbox');
  if (!lightbox) return;

  var lbContent = document.getElementById('pdp-rl-lightbox-content');
  var lbClose = lightbox.querySelector('.pdp-rl-lightbox__close');
  var lbPrev = lightbox.querySelector('.pdp-rl-lightbox__prev');
  var lbNext = lightbox.querySelector('.pdp-rl-lightbox__next');
  var lbCounter = lightbox.querySelector('.pdp-rl-lightbox__counter');
  var lbIndex = 0;

  function showLbMedia(index) {
    var media = getAllMedia();
    if (media.length === 0) return;
    lbIndex = ((index % media.length) + media.length) % media.length;
    var item = media[lbIndex];

    if (item.type === 'video') {
      lbContent.innerHTML = '<video class="pdp-rl-lightbox__video" src="' + item.src + '" controls autoplay playsinline></video>';
    } else {
      lbContent.innerHTML = '<img src="' + item.src + '" alt="Gallery image" class="pdp-rl-lightbox__img">';
    }
    lbCounter.textContent = (lbIndex + 1) + ' / ' + media.length;
  }

  function openLightbox(index) {
    showLbMedia(index);
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
    lbContent.innerHTML = '';
  }

  // Click handlers on gallery items
  gallery.querySelectorAll('.pdp-rl-gallery__media').forEach(function(media) {
    media.addEventListener('click', function() {
      var item = this.closest('[data-index]');
      if (item) openLightbox(parseInt(item.getAttribute('data-index')));
    });
  });

  lbClose.addEventListener('click', closeLightbox);
  lbPrev.addEventListener('click', function(e) { e.stopPropagation(); showLbMedia(lbIndex - 1); });
  lbNext.addEventListener('click', function(e) { e.stopPropagation(); showLbMedia(lbIndex + 1); });

  lightbox.addEventListener('click', function(e) {
    if (e.target === lightbox) closeLightbox();
  });

  document.addEventListener('keydown', function(e) {
    if (!lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') showLbMedia(lbIndex - 1);
    if (e.key === 'ArrowRight') showLbMedia(lbIndex + 1);
  });
})();
